import React from "react";
import { Sparkles } from "lucide-react";
import { Loader } from "@/components/ui/loader";

export const ProcessingPlaceholder: React.FC = () => (
  <div className="relative">
    <div className="flex flex-col items-center justify-center rounded-md border border-coral/20 bg-coral/5 py-8">
      <Sparkles className="mb-3 h-8 w-8 animate-pulse text-coral" />
      <div className="flex items-center gap-2">
        <Loader className="h-5 w-5 text-coral" />
        <span className="text-base font-medium text-coral">Regenerating section...</span>
      </div>
    </div>
  </div>
);
